export default function Footer() {
  return (
    <footer className="bg-[#0F172A] rounded-t-[32px]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Left Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/e5292f43a8fca29a2b9f75d3d42cfb52/a79cb0bec034472cb10b80478a2788a7.png" 
                alt="iCarga Logo" 
                className="h-12 w-12 rounded-full object-cover"
              />
              <span className="text-3xl font-bold text-white">iCarGA</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Your trusted partner for quality used cars in Fayetteville. We make car buying simple, transparent, and hassle-free.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-600 text-gray-400 hover:border-white hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-600 text-gray-400 hover:border-white hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-600 text-gray-400 hover:border-white hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Middle Column */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="/inventory" className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer">
                  Search Inventory
                </a>
              </li>
              <li>
                <a href="#financing" className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer">
                  Financing Options
                </a>
              </li>
              <li>
                <a href="/sell-trade" className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer">
                  Sell/Trade
                </a>
              </li>
              <li>
                <a href="/reviews" className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer">
                  Customer Reviews
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 text-sm hover:text-white hover:underline transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Right Column */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm">Visit Us</h3>
            <div className="space-y-4">
              <p className="text-gray-400 text-sm leading-relaxed">
                320 W. Lanier Ave. Ste 226<br />
                Fayetteville, GA 30214
              </p>
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-phone-line"></i>
                <span>(404) 852-7336</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-mail-line"></i>
                <span>icargamail@gmail.com</span>
              </div>
              <p className="text-gray-500 text-sm">
                Hours: Mon-Sat 9AM-7PM
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">© 2025 iCarga. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#privacy" className="text-gray-500 text-sm hover:text-white hover:underline transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#terms" className="text-gray-500 text-sm hover:text-white hover:underline transition-colors cursor-pointer">
              Terms of Service
            </a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-500 text-sm hover:text-white hover:underline transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
